module.exports = __webpack_public_path__ + "img/AddLocationAltOutlined.66f80ac0.svg";